module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['content', {
      'zh-style': _vm.language === 'zh'
    }]
  }, [_c('empty-reminder', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.records.length == 0 && !_vm.loading),
      expression: "records.length == 0 && !loading"
    }]
  }), _vm._v(" "), (_vm.records.length > 0) ? _c('div', {
    staticClass: "pc-records"
  }, [_c('div', {
    staticClass: "little-title"
  }, [_c('p', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.$t('time')))]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.$t('description')))])]), _vm._v(" "), _vm._l((_vm.records), function(record) {
    return _c('div', {
      staticClass: "records"
    }, [_c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm._f("createFormatTime")(record.created_at, record.created_at)))]), _vm._v(" "), _c('p', {
      staticClass: "description"
    }, [_c('span', [_vm._v(_vm._s(_vm.getDescription(record.nickname, record.status)))])])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.records.length > 0) ? _c('div', {
    attrs: {
      "id": "pager-bar"
    }
  }, [_c('div', {
    staticClass: "spinner-component-box"
  }, [_c('spinner', {
    attrs: {
      "show": _vm.loading
    }
  })], 1), _vm._v(" "), _c('pager', {
    attrs: {
      "totalPage": _vm.totalPage,
      "init-page": _vm.currentPage,
      "mode": "event"
    },
    on: {
      "go-page": _vm.getFriendRecords
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a933c3b4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/affiliate/friendRecords/FriendRecordsPc.vue
// module id = 1377
// module chunks = 1